import { defineStore } from 'pinia'

import type { KidStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useKidStore = defineStore('kid', {
  state: (): KidStore => ({
    kid: null,
    form: {
      name: '',
      grade: null,
      voip: null,
      notes: null,
    },
    customerIsGo: false,
    processing: 0,
    modalDelete: false,
    modalAddDiscipline: false,
  }),
  actions,
  getters,
})
